import { DialogProps, Typography } from '@mui/material';
import { Secret } from 'api/model.ts';
import SecretModelUsageDialog from './SecretModelUsageDialog';
import SecretNodeUsageDialog from './SecretNodeUsageDialog';

type Props = DialogProps & {
  secret: Secret;
  open: boolean;
  onClose: () => void;
};

const SecretUsageDialog = (props: Props) => {
  if (props.secret.type === 'api_key') {
    return <SecretModelUsageDialog {...props} />;
  } else if (props.secret.type === 'git_auth' || props.secret.type === 'coding_agent_credentials') {
    return <SecretNodeUsageDialog {...props} />;
  } else {
    return <Typography>Unsupported secret type</Typography>;
  }
};

export default SecretUsageDialog;
